import { useMember } from "src/patents/PatentsProvider";
import { RenewalOverviewProvider } from "./RenewalOverview";
import { useSettings } from "./Settings";

export function MemberRenewalOverviewProvider({children}: {children: React.ReactNode}) {
    const { member } = useMember()
    const {implementation} = useSettings()
    // console.log({member, implementation})

    if (!member) return null

    if (implementation === 'none') return children as JSX.Element

    return (
      <RenewalOverviewProvider {...{ familyMemberId: member.familyMemberId }}>
        {children}
      </RenewalOverviewProvider>
    )
}